import "./ChangePasswordModal.css";
import { useNavigate } from "react-router-dom";

const ChangePasswordModal = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const handleUpdatePassword = () => {
    // password update logic here

    navigate(-1); // same page la back yeil
  };

  return (
    <div className="cp-overlay">
      <div className="cp-modal">
        {/* HEADER */}
        <div className="cp-header">
          <h2>Change Password</h2>

          <span className="cp-close" onClick={handleClose}>
            ✕
          </span>
        </div>

        {/* FORM */}
        <div className="cp-body">
          <label>Current Password</label>
          <input type="password" />

          <label>New Password</label>
          <input type="password" />

          <label>Confirm New Password</label>
          <input type="password" />
        </div>

        {/* FOOTER */}
        <div className="cp-footer">
          <button className="cp-btn cancel" onClick={handleClose}>
            Cancel
          </button>

          <button className="cp-btn primary" onClick={handleUpdatePassword}>
            Update Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
